import CancerPage from "../components/CancerPage";

const stepsText = [
  "Excisional Biopsy: This is the most crucial step. The entire suspicious lesion is surgically removed and sent to a pathology lab for histopathological analysis.",
  "Lymph Node Evaluation: If the biopsy confirms melanoma, particularly if it is thick or ulcerated, a sentinel lymph node biopsy may be recommended to check for cancer spread.",
  "Imaging Studies (CT, PET-CT): For thicker melanomas or those that have spread to the lymph nodes, imaging scans may be necessary to assess the full extent of the disease.",
  "Dermatological Examination of the Entire Body: A thorough skin exam is necessary to check for any other suspicious lesions.",
  "Blood Tests: To check for general health, assess organ function, and, in some cases of advanced melanoma, to look for specific genetic mutations (e.g., BRAF mutation).",
];

export default function EpidermisCancerPage() {
  return (
    <CancerPage
      cancerName="Epidermis Cancer"
      scanType="Dermoscopic image"
      analysisText="Based on the provided dermoscopic image, a thorough examination of the lesion reveals several concerning features. The lesion displays asymmetry in both its shape and the distribution of color and structural patterns. It exhibits a disorganized, atypical pigment network with thick lines and irregular holes. The lesion contains multiple colors (e.g., black, brown, blue, and gray) and may show specific structures such as irregular streaks, dots/globules, and a blue-white veil. The presence of these characteristics is highly suspicious for a primary melanocytic malignancy, such as melanoma."
      stepsTitle="Necessary Steps Following an Abnormal Dermoscopic Image:"
      stepsText={stepsText}
    />
  );
}
